module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ind",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "id": "start"
    }
  }, [_c('a', {
    attrs: {
      "id": "epigraph"
    }
  }, [_vm._v("“The "), _c('i', [_vm._v("gentleman")]), _vm._v(" tells us that America is obstinate; that America is almost in open rebellion. Sir, I rejoice that America has resisted…")])]), _c('a', {
    attrs: {
      "id": "epigraph"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“The gentleman asks when were the colonies emancipated. But I desire to know when they were made slaves…")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“They are subjects of this kingdom, equally entitled with yourselves to all the natural rights of mankind, and the peculiar privileges of Englishmen; equally bound by its laws, and equally participating in the constitution of this free country. The Americans are the sons, not the bastards, of England.”")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("1766:")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("William Pitt the Elder,")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("before Parliament,")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("in support of repeal")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("of the Stamp Act.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2036a89d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/5-start.vue
// module id = 84
// module chunks = 0